let debounced = null;
const useDebounce = (callBack, timeout) => {
    clearTimeout(debounced);
    debounced = setTimeout(() => {
        callBack();
    }, timeout);
};

export default useDebounce;